import React from 'react';

const ElfsightWidget = () => {
  return (
    <>
      <h5>
        <b>Elfsight widgets</b>
      </h5>
      <p>
        The Elfsight Widgets plugin allows you to easily embed Elfsight widgets to increase sales,
        engage visitors and connect leads to your web app
      </p>
      <br />
    </>
  );
};

export default ElfsightWidget;
